import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { ConfigService } from '../services/config.service';

@Injectable()
export class CareerPlansGuard  {
  constructor(private configuration: ConfigService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.configuration.get().showCareerPlanFeatures;
  }
}
